<template>
  <div id="app">
    <router-view v-if="isRoutrtAlive"/>
  </div>
</template>
<script>
export default {
	name: 'App',
	provide() {
		return {
			reload: this.reload
		}
	},
	data() {
		return {
			isRoutrtAlive: true
		}
	},
	methods: {
		reload() {
			this.isRoutrtAlive = false
			this.$nextTick(()=>this.isRoutrtAlive=true)
		}
	}
}
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
